<!-- eslint-disable max-lines -->
<template>
    <div class="file-detail-subtab">
        <div class="file-detail-btn" v-if="!readonly">
            <lots-button
                v-if="isShowOppBtn"
                v-has="authorityCode.subAddNewOpportunity"
                type="text" icon="el-icon-circle-plus-outline" size="medium" @click="handleAddRow('opportunity')"
                :disabled="isDisableBtn">新增商机 </lots-button>
                <!-- v-if="!detailData.projectCode || +projectData.isLinkOppo !== 1 || btnPermissionsArr.includes(authorityCode.subAddNewCompanyS)" -->
            <lots-button
                v-has="authorityCode.subAddNewCompany" type="text" icon="el-icon-circle-plus-outline" v-if="isShowCompany" size="medium"
                 @click="handleAddRow('company')" :disabled="isDisableBtn">新增分公司</lots-button>
            <!-- <lots-button type="text" icon="el-icon-circle-check" size="medium" @click="handleSaveRows" v-show="detailPageState !== STATE_NEW" :disabled="isDisableBtn">保存</lots-button> -->
            <lots-button
                v-has="authorityCode.subAddNewCompanyBatch"
                v-if="detailData.contractGroupCode && $route.name === 'contractGroupManage'"
                type="text" icon="el-icon-refresh" size="medium" @click="handleSyncData" v-show="detailPageState !== STATE_NEW" :disabled="isDisableBtn">批量更新分公司</lots-button>
            <lots-button
                v-has="authorityCode.subDeleteCompany"
                type="text" icon="el-icon-delete" size="medium" @click="handleDeleteRows('normal')" v-show="detailPageState !== STATE_NEW" :disabled="isDisableBtn">删除</lots-button>
            <lots-button
                v-has="authorityCode.subAddNewOpportunityPrivilege"
                v-show="![STATE_NEW, STATE_OTHER_CHANGE].includes(detailPageState) && $route.name !== 'contractGroupManage'"
                type="text" icon="el-icon-circle-plus-outline" size="medium" @click="handleAddRow('opportunityPrivilege')">
                特权新增商机
            </lots-button>
            <lots-button
                v-has="authorityCode.subDeleteCompanyPrivilege"
                v-show="![STATE_NEW, STATE_OTHER_CHANGE].includes(detailPageState) && $route.name !== 'contractGroupManage'"
                type="text" icon="el-icon-delete" size="medium" @click="handleDeleteRows('privilege')" :loading="privilegeDeleteLoading">
                特权删除
            </lots-button>
            <lots-button
                v-has="authorityCode.subAddSiteCompanyBatch"
                v-if="!hiddenSiteBatch"
                type="text" icon="el-icon-circle-plus-outline" size="medium"
                @click="handleAddSiteBatch"
                :disabled="isDisableBtn || (!detailData.contractCode && !editTableTotalData.length)"
                :loading="privilegeDeleteLoading">
                批量维护服务平台
            </lots-button>
        </div>
        <div class="red-tips" v-if="isShowTips">分公司由商机带出！不允许手工新增！</div>
        <div class="company-detail-table">
            <edit-table-box
                v-if="detailPageState === 'new'"
                class="prescreen"
                ref="editTableBox"
                :selection="config.selection"
                :cell-class-name="setCellCassName"
                :columns="config.columns"
                :key="editTableKey"
                :height="tableHeight"
                :tableData="editTableTotalData"
                @selection-change="handleSelectedRow"
                @element-change="handleChangeRow">
                <template #col-append="{ item, row }">
                    <span v-if="item.prop === 'site'">{{row['siteNames']}}</span>
                </template>
                <template #edit-col-append="{ item, row, rIndex }">
                    <otpAdvanceMulti
                        v-if="item.prop === 'site' && detailPageState === 'new' && !row.disableProps.includes(item.prop)"
                        :ref="'advanceMuti' + rIndex"
                        @getAdvanceValue="(data) => { getAdvanceValue(data, row, item); }"
                        :mValue="row.site"
                        :formData="{ companyCode: row.companyCode }"
                        :params="item"
                        :disabled="row.disableProps ? row.disableProps.includes(item.prop) : true">
                    </otpAdvanceMulti>
                </template>
            </edit-table-box>
            <table-box
                v-else
                ref="tableBoxRead"
                :height="tableHeight"
                :selection="true"
                v-loading="subTabTable.tableLoading"
                :columns="detailData.contractGroupCode ? config.columnsGroupReadonly : config.columnsReadonly"
                :rows="subTabTable.totalData"
                :actions="actions"
                :cell-class-name="setCellCassName"
                @selection-change="handleSelectedRow"
                @action-click="actionClick"
                @row-click="handleRowClick">
                    <template v-slot:col-append="{ col, row }">
                        <div v-if="col.prop === 'isPureWarehouse'">
                            <lots-select
                                v-model="row[col.prop]"
                                :optionsKey="col.optionsKey"
                                :disabled="readonly || isDisableBtn || (detailData.oilIsGroupCustomer + '' === '0')"
                                :placeholder="(readonly || isDisableBtn) ? '' : '请选择'"
                                @change="(data) => { changeIsWarehouse(row, data) }">
                            </lots-select>
                        </div>
                        <div v-else-if="col.prop === 'companyName'">
                            <span v-if="row.isSelected">
                                <lots-md-input
                                    :label="row[col.prop]"
                                    :config="config.companyParamsAdvance"
                                    @change="(data) => { getAdvanceValue(data, row, col); }"
                                ></lots-md-input>
                            </span>
                            <span v-else>{{ row[col.prop] }}</span>
                        </div>
                    </template>
                </table-box>
            <div class="footer">
                <el-pagination
                    v-if="detailPageState !== 'new'"
                    :current-page.sync='subTabTable.pageNo'
                    :pageSize='subTabTable.pageSize'
                    size="small"
                    layout='total, sizes, prev, pager, next, jumper'
                    :page-sizes="[100, 200, 500, 1000]"
                    :total='subTabTable.pageTotal'
                    @size-change='subTabTable.sizeChange'
                    @current-change='subTabTable.pageChange'
                    >
                </el-pagination>
            </div>
        </div>
        <!-- 添加分公司（非初次新增合同） -->
        <advance-dialog
            ref="advanceDialog"
            @confirm="companySaveSure">
        </advance-dialog>
        <!-- 批量添加分公司（新增合同时）或服务平台（编辑合同时） -->
        <advance-multi-dialog
            ref="advanceMultiDialog"
            @confirm="detaliSearchSure"
            @getCheckedList="detailCheckedList">
        </advance-multi-dialog>
        <!-- 新增商机-弹框（新增 / 编辑） -->
        <opportunityList
            v-if="opportunityListVisible"
            :detailData="detailData"
            :detailPageState="detailPageState"
            @handleClose="updateOpportunityListVisible"
            @confirm="(data) => addOpportunityConfirm(data, 'normal')"></opportunityList>
        <!-- 特权新增商机-弹框 -->
        <opportunityPrivilege
            v-if="opportunityPrivilegeVisible"
            :detailData="detailData"
            :detailPageState="detailPageState"
            @handleClose="updateOpportunityPrivilegeVisible"
            @confirm="(data) => addOpportunityConfirm(data, 'privilege')"></opportunityPrivilege>
        <tableMutiAdvanceDialog ref="advanceDialogRef" @confirm="(data,config)=>addOpportunityConfirm(data,'normal',config)"></tableMutiAdvanceDialog>
        <tableMutiAdvanceDialog ref="privilegeRef" @confirm="(data)=>addOpportunityConfirm(data,'privilege')"></tableMutiAdvanceDialog>
    </div>
</template>

<script>
import { ref, reactive, watch, onMounted, computed, getCurrentInstance } from '@vue/composition-api';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import tableBox from '@/components/lots/tableBox/Index';
import otpAdvanceMulti from '@/components/lots/otpAdvanceMulti';
import lotsMdInput from '@/components/lots/lotsMdInput';
import advanceDialog from '@/components/lots/otpAdvanceDialog';
import lotsSelect from '@/components/lots/lotsSelect/Index';
import advanceMultiDialog from '@/components/lots/otpAdvanceMultiDialog';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { tableConfig } from './config.js';
import { Message, MessageBox } from 'element-ui';
import { STATE_OTHER_CHANGE, STATE_NEW, STATE_MAIN } from '@/modules/mdm/constant/contractManage.js';
import {
    companyList, companyDelete, companyAddBatch, otherChangeCompanyList, otherChangeCompanyDelete,
    otherChangeCompanyAddBatch, siteInfoSave, siteChangeSave, getCdTsCustomerProjectsApi, companyUpdateBatch,
    privilegeAddBatch, privilegeRemove, siteUpdateBatch, changeSiteUpdateBatch, siteInfoSavePrivilege, getSiteInfoCompanyAll,
    getChangeSiteInfoCompanyAll, getSiteBatch, updateCompanyName
} from '@mdm/api/contractManage/contractFootPageApi.js';
import { opportunityPreVerify } from '@mdm/api/contractManage/detailMainApi.js';
import opportunityList from './opportunityList/Index.vue';
import opportunityPrivilege from './opportunityListPrivilege/Index.vue';
import _ from 'lodash';
import store from '@/store/index';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import tableMutiAdvanceDialog from '@/modules/mdm/views/contractModules/components/tableMutiAdvanceDialog/Index';
const companyApi = '/contract/company/base/page';
const changeCompanyApi = '/contract/company/change/base/page';
export default {
    name: '',
    components: {
        editTableBox,
        tableBox,
        lotsMdInput,
        otpAdvanceMulti,
        advanceMultiDialog,
        advanceDialog,
        opportunityList,
        lotsButton,
        lotsSelect,
        opportunityPrivilege,
        tableMutiAdvanceDialog },
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailPageState: {
            type: String,
            default() {
                return '';
            }
        },
        detailData: {
            type: Object,
            return: () => {}
        },
        tableHeight: {
            type: Number,
            default: 325
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.contractManage);
        const btnPermissionsArr = store.getters.btnPermissions;
        const config = reactive(_.cloneDeep(tableConfig));
        let listApi = reactive({});
        let deleteApi = reactive({});
        const isDisableBtn = ref(false);
        const actions = reactive({
            fixedWidth: 250,
            list: [
                {
                    label: '维护服务平台',
                    event: 'addSite',
                    displayRule: (row) => {
                        return !!row.id && !isDisableBtn.value && btnPermissionsArr.includes(authorityCode.subAddSiteCompany) && !props.readonly;
                    }
                },
                {
                    label: '特权添加服务平台',
                    event: 'addSitePrivilege',
                    displayRule: (row) => {
                        return !!row.id && btnPermissionsArr.includes(authorityCode.subAddSiteCompanyPrivilege)
                            && props.detailPageState !== STATE_OTHER_CHANGE;
                    }
                }
            ]
        });
        if (props.detailPageState === STATE_OTHER_CHANGE && +props.detailData.changeType === 0) {
            listApi = otherChangeCompanyList;
            deleteApi = otherChangeCompanyDelete;
        } else {
            listApi = companyList;
            deleteApi = companyDelete;
        }
        class DataDetailClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.contractCode = props.detailData.contractCode === '0000' ? '' : props.detailData.contractCode;
                if (props.detailPageState === STATE_OTHER_CHANGE && +props.detailData.changeType === 0) {
                    condition.contractChangeCode = props.detailData.contractChangeCode;
                }
                return condition;
            };
            async afterGetList(res) { // 展示的表格呈编辑状态
                if (+res.code === 0) {
                    res.data.list.forEach((e, i) => {
                        e.edit = -3;
                    });
                    this.totalData.value = res.data.list.map(item => {
                        return {
                            ...item,
                            opportunityCode: item.opportunityCode || '',
                            opportunityName: item.opportunityName || '',
                            isSelected: undefined
                        };
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
                // 变更弹，主合同显示
                if (props.detailPageState === STATE_OTHER_CHANGE || props.detailPageState === STATE_MAIN) {
                    getSiteBatchBtn();
                }
            };
            async afterDeleteRow(res) {
                if (res && +res.code === 0) {
                    Message.success('删除成功');
                    await this.getList();
                    if (props.detailPageState === STATE_OTHER_CHANGE) return;
                    setupContext.emit('changeProjectCode', { list: oldSelectedRows.value.map(it => it?.projectCode).filter(it => it), type: 'del' });
                }
                // await setOpportunityEmitData();
                setupContext.emit('updataDetail');
                oldSelectedRows.value = [];
            }
        };
        const subTabTable = new DataDetailClass({
            Api: {
                listApi,
                deleteApi
            },
            pageSize: 100
        });
        const opportunityPrivilegeVisible = ref(false); // LCRM商机弹框
        const updateOpportunityPrivilegeVisible = (val) => {
            opportunityPrivilegeVisible.value = val;
        };
        const opportunityAdvance = computed(() => {
            function getAdvanceConfig(row) {
                const beforeRequest = (params) => {
                    params.companyCode = row.companyCode;
                    return params;
                };
                return { ...config.opportunityAdvance, beforeRequest };
            }
            return getAdvanceConfig;
        });
        // eslint-disable-next-line complexity
        const isShowCompany = computed(() => {
            // {"0":"内部","1":"外部","2":"内部加外部"}
            const { isLinkOppo, oilIsGroupCustomer, contractSource } = props.detailData;
            if (props.detailPageState === STATE_OTHER_CHANGE) { // 其他变更
                return true;
            } else if (+oilIsGroupCustomer === 0) {
                return true;
            } else if ([4, 6].includes(+contractSource)) { // 合同来源=JDSK/银行；
                return true;
            } else if (+oilIsGroupCustomer === 1 && +isLinkOppo !== 1 && props.detailPageState === 'new' && editTableTotalData.value.length) {
                // 内外部业务=外部，且分公司明细至少有一条记录，且分公司明细不存在关联商机“校验关联商机"IS_LINK_OPPO=1是的数据（即不等于1），才显示”新增分公司“按钮；
                return true;
            } else if (+oilIsGroupCustomer === 1 && +isLinkOppo !== 1 && subTabTable.totalData.value.length) {
                return true;
            }
            return false;
        });
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const isShowTips = computed(() => {
            // 、当内外部业务=外部时，合同状态=草稿/新增时，增加红字提示语：分公司由商机带出！不允许手工新增！
            const { contractStatus, oilIsGroupCustomer } = props.detailData;
            return ['1', '0'].includes(String(contractStatus)) && +oilIsGroupCustomer === 1;
        });
        const isShowOppBtn = computed(() => {
            const isGroup = (props.detailData.contractGroupCode && ctx.$route.name === 'contractGroupManage'); // 合同组
            const isOilIs = +props.detailData.oilIsGroupCustomer !== 0;
            return isGroup ? false : isOilIs;
        });
        const handleRowClick = (row) => {
            // setupContext.refs.tableBoxRead.$refs.elTable.toggleRowSelection(row);
            config.columnsReadonly.forEach(it => {
                // 当合同状态=草稿/新增，且合同内外部业务=外部，且合同分公司明细未关联服务平台，且合同分公司明细的商机号有值，
                // 且合同分公司明细的商机号所关联商机表（B表）的分公司字段不包含“分公司”时
                if (it.prop === 'companyName') {
                    const isEdit = row.opportunityCode && +row.isModify === 1 && !row.siteNames?.length
                 && (props.detailPageState === STATE_NEW || [0, 1].includes(+props.detailData.contractStatus));
                    it.type = isEdit ? 'custom' : null;
                }
            });
            subTabTable.totalData.value.forEach(item => {
                if (item.id === row.id) {
                    item.isSelected = true;
                } else {
                    item.isSelected = undefined;
                }
            });
        };
        const editTableKey = ref(true);
        const btnLoading = ref(false);
        const handleType = ref(''); // 多选弹框打开变量：company打开分公司 site打开服务平台
        const handleAddRow = async (type) => {
            if (type === 'company') {
                companyAddRow();
            } else if (type === 'opportunity') {
                // 商机列表弹框
                const _config = _.cloneDeep(config);
                // _config.opportunityMuiAdvance.noCloseDialog = props.detailData.contractCode ? _.isNil(props.detailData.changeType) || props.detailPageState !== STATE_OTHER_CHANGE
                // // eslint-disable-next-line no-mixed-operators
                //     || !(props.detailData.contractGroupCode && ctx.$route.name === 'contractGroupManage') : false;
                // if (props.detailData.contractAttribute?.toString() === '2') {
                _config.opportunityMuiAdvance.noCloseDialog = true;
                // }
                setupContext.refs.advanceDialogRef.show(true, _config.opportunityMuiAdvance);
                // updateOpportunityListVisible(true);
            } else if (type === 'opportunityPrivilege') {
                // LCRM商机列表弹框
                // updateOpportunityPrivilegeVisible(true);
                setupContext.refs.privilegeRef.show(true, config.opportunityMuiAdvance);
            }
        };
        const companyAddRow = async () => {
            const { params, apiUrl } = getCompanyParams({}, companyApi, changeCompanyApi);
            config.companyAdvanceParams.advanceUrl = apiUrl;
            setupContext.refs.advanceMultiDialog.show(true, config.companyAdvanceParams, params, allCompanyList.value);
            handleType.value = 'company';
        };
        // initParams 初始参数，initUrl 初始url changeUrl 变更单url
        const getCompanyParams = (initParams = {}, initUrl = '', changeUrl = '') => {
            const params = { ...initParams, contractCode: props.detailData.contractCode };
            let apiUrl = initUrl;
            if (props.detailData.contractChangeCode) {
                apiUrl = changeUrl;
                params.contractChangeCode = props.detailData.contractChangeCode;
            }
            return {
                params,
                apiUrl
            };
        };
        const allCompanyList = ref([]);
        const selectedRows = ref([]); // 选中的行数组
        const handleSelectedRow = (selection) => {
            selectedRows.value = selection;
        };
        const handleChangeRow = ({ prop, val, type, row, index }) => {
            if (type === 'advance' && props.detailPageState === STATE_NEW) {
                if (val['companyCode']) {
                    row.disableProps = [];
                    row.site = [];
                    // 为了解决改变分公司，清空服务平台数据后，点击服务平台弹框，弹框选中数据依旧保留原来选中的数据的bug(暂时找不到更好的办法)
                    row.disableProps = ['site', 'companyName'];
                    row.isModify = '0';
                    setTimeout(() => {
                        row.disableProps = ['companyName'];
                    }, 100);
                } else {
                    row.disableProps = ['site'];
                    row.site = [];
                }
            }
            // else if (prop === 'companyName' && props.detailPageState === STATE_NEW) {
            //     console.log('888,', prop, val, type, row, index);
            //     if (val['siteNames']) {
            //         row.disableProps = row.disableProps.filter(it => it !== 'companyName');
            //     }
            // }
        };
        // eslint-disable-next-line complexity
        const getAdvanceValue = _.debounce((data, row, item) => {
            if (item.prop === 'site') {
                row[item.prop] = data;
                allSiteList.value = allSiteList.value.filter(it => it.companyCode !== row.companyCode);
                const selectList = data.map(it => {
                    return {
                        companyCode: row.companyCode,
                        companyNameCn: row.companyName,
                        siteCode: it.siteCode,
                        siteNameCn: it.siteName
                    };
                });
                allSiteList.value = otherUtils.distinctData(allSiteList.value.concat(selectList), 'siteCode');
                // row.isModify = '0';
                // const isEdit = row.opportunityCode && +props.detailData.isLinkOppo === 1 && (props.detailPageState === STATE_NEW || +props.detailData.contractStatus === 0);
                // if (!data.length && isEdit) {
                //     row.disableProps = row.disableProps.filter(it => it !== 'companyName');
                //     row.isModify = '1';
                // }
            } else if (item.prop === 'opportunityCode') {
                Object.keys(data).forEach(key => {
                    row[key] = data[key];
                });
                companySaveSure([row], 'privilege'); // 特权编辑商机数据保存
            } else if (item.prop === 'companyName') {
                Object.keys(data).forEach(key => {
                    row[key] = data[key];
                });
                row.disableProps && row.disableProps.push('companyName');
                if (+row.isModify === 1) {
                    updateCompanyHandle(data, row);
                } else {
                    companySaveSure([row]);
                }
            }
        }, 100);
        const updateCompanyHandle = (data, row) => {
            if (!data.companyName) return;
            const params = {
                contractCode: props.detailData.contractCode,
                companyName: data.companyName,
                companyCode: data.companyCode,
                id: row.id
            };
            updateCompanyName(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('保存成功');
                    subTabTable.getList();
                }
            });
        };
        const oldSelectedRows = ref([]);

        const privilegeDeleteLoading = ref(false);
        const handleDeleteRows = async (type) => { // 调批量删除接口
            if (selectedRows.value.length === 0) {
                Message.warning('请选择需要删除的条目');
                return;
            }
            let passFlag = true;
            selectedRows.value.forEach(item => {
                if (!item.id) {
                    passFlag = false;
                }
            });
            if (!passFlag) return Message.warning('存在新增未保存的数据，请先保存或取消编辑');
            const ids = JSON.parse(JSON.stringify(selectedRows.value)).map((v) => v.id);
            const params = { ids };
            if (props.detailPageState === STATE_OTHER_CHANGE) {
                params.contractChangeCode = props.detailData.contractChangeCode;
            } else {
                params.contractCode = props.detailData.contractCode;
            }
            if (type && type === 'privilege') { // 特权删除
                MessageBox.confirm(`请确认是否删除勾选的${selectedRows.value.length}条数据？`, '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    privilegeDeleteLoading.value = true;
                    privilegeRemove(params).then(async res => {
                        if (+res.code === 0) {
                            Message.success('删除成功');
                            await subTabTable.getList();
                            if (props.detailPageState === STATE_OTHER_CHANGE) return;
                            // setOpportunityEmitData();
                            setupContext.emit('updataDetail');
                            setupContext.emit('changeProjectCode', { list: selectedRows.value.map(it => it?.projectCode).filter(it => it), type: 'del' });
                        }
                    }).finally(() => {
                        privilegeDeleteLoading.value = false;
                    });
                });
            } else { // 普通删除
                await subTabTable.deleteRow(params, false);
                oldSelectedRows.value = _.cloneDeep(selectedRows.value);
                // await subTabTable.getList();
                // setupContext.emit('changeProjectCode', subTabTable.totalData.value.map(it => it?.projectCode).filter(it => it));
                // setOpportunityEmitData();
            }
        };
        // const
        const handleSyncData = () => {
            if (!subTabTable.totalData.value.length) {
                return Message.warning('分公司信息为空，请添加分公司、服务平台数据');
            }
            MessageBox.confirm('此操作将更新该合同组下所有合同明细分公司、服务平台数据，确认继续吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                companyUpdateBatch({
                    contractCode: props.detailData.contractCode,
                    contractGroupCode: props.detailData.contractGroupCode
                }).then(res => {
                    if (+res.code === 0) {
                        Message.success('更新成功');
                        subTabTable.getList();
                    }
                });
            });
        };
        watch(
            () => [props.detailPageState, props.detailData.contractStatus, props.detailData.contractChangeStatus, props.activeName, props.detailData.contractCode, props.detailData.businessType],
            // eslint-disable-next-line complexity
            async (newVal) => {
                if (newVal[3] === 'companyDetail') {
                    config.columns.forEach((item) => {
                        if (item.prop === 'site') {
                            item.mustFill = newVal[0] === STATE_NEW;
                            item.disabled = newVal[0] !== STATE_NEW;
                        } else if (item.prop === 'isPureWarehouse') {
                            item.mustFill = Boolean(newVal[5] && newVal[5].length && newVal[5].some(item => (item === '1' || item === '2')));
                            item.disabled = props.detailData.oilIsGroupCustomer + '' === '0';
                        }
                    });
                    config.columnsReadonly.forEach((item) => {
                        if (item.prop === 'isPureWarehouse') {
                            item.mustFill = Boolean(newVal[5] && newVal[5].length && newVal[5].some(item => (item === '1' || item === '2')));
                            item.disabled = props.detailData.oilIsGroupCustomer + '' === '0';
                        }
                    });
                    setTimeout(() => {
                        editTableKey.value = !editTableKey.value;
                    }, 1000);
                    if (newVal[0] === STATE_NEW) {
                        isDisableBtn.value = false;
                    } else if (newVal[0] === STATE_OTHER_CHANGE) {
                        isDisableBtn.value = newVal[2] + '' === 'undefined' || newVal[2] + '' !== '1' || ([1, 2].includes(+props.detailData.changeType)); // 价格信息、日期信息变更只读
                    } else {
                        isDisableBtn.value = !(newVal[1] + '' === '0' || newVal[1] + '' === '1');
                    }
                    if (newVal[4]) {
                        if (((newVal[0] !== STATE_NEW) && (newVal[0] !== STATE_OTHER_CHANGE)) || (newVal[0] === STATE_OTHER_CHANGE && props.detailData.contractChangeCode)) {
                            await subTabTable.getList();
                            if (props.detailData.projectCode) {
                                getCdTsCustomerProjectsApi({ projectCode: props.detailData.projectCode }).then(res => {
                                    if (+res.code === 0 && res.data.list && res.data.list.length) {
                                        projectData.value = res.data.list[0];
                                    }
                                });
                            }
                        }
                    } else {
                        subTabTable.totalData.value = [];
                        subTabTable.pageTotal.value = 0;
                    }
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        const siteDetailData = ref({});
        const actionClickIndex = ref(null); // 点击的行索引值
        const privilege = ref(false);
        const actionClick = (event, row, index) => {
            actionClickIndex.value = index;
            if (['addSite', 'addSitePrivilege'].includes(event)) {
                if (row.id) { // 有id则允许添加
                    if (!checkIsWarehouse([row])) {
                        return false;
                    }
                    privilege.value = event === 'addSitePrivilege';
                    const ininParams = { companyCode: row.companyCode, contractCode: props.detailData.contractCode };
                    const { params } = getCompanyParams(ininParams);
                    const siteALlList = (row.site || row.siteList || []).map(it => {
                        it.companyCode = row.companyCode;
                        it.siteNameCn = it.siteName;
                        it.companyName = row.companyName;
                        it.contractCode = row.contractCode;
                        return it;
                    });
                    setupContext.refs.advanceMultiDialog.show(true, config.siteAdvanceParams, params, siteALlList);
                    handleType.value = 'site';
                } else {
                    Message.warning('分公司未保存');
                }
            }
        };
        const editTableTotalData = ref([]);
        const siteList = ['siteBatch', 'site', 'newSiteBatch', 'company'];
        // eslint-disable-next-line complexity
        const detaliSearchSure = async (data) => {
            // if (!data.length && (handleType.value !== 'siteBatch' || )) return;
            if (!data.length && (siteList.indexOf(handleType.value) < 0)) return;
            if (handleType.value === 'site') { // 主合同状态，批量添加服务平台弹框确认
                const params = {
                    companyCode: subTabTable.totalData.value[actionClickIndex.value].companyCode,
                    contractCode: props.detailData.contractCode,
                    contractChangeCode: props.detailData.contractChangeCode ? props.detailData.contractChangeCode : undefined,
                    siteList: setCurrentSiteList(data, props.detailData.contractCode)
                };
                let res = '';
                if (props.detailPageState === STATE_OTHER_CHANGE) { // 其他变更添加
                    params.contractCompanyId = subTabTable.totalData.value[actionClickIndex.value].id;
                    res = await siteChangeSave(params);
                } else {
                    params.contractCompanyId = subTabTable.totalData.value[actionClickIndex.value].id;
                    if (privilege.value) { // 特权添加
                        res = await siteInfoSavePrivilege(params);
                    } else { // 普通添加
                        res = await siteInfoSave(params);
                    }
                }
                if (res.code === '0') {
                    Message.success('保存成功');
                    subTabTable.getList();
                }
            } else if (handleType.value === 'siteBatch') {
                const initParams = {
                    contractCode: props.detailData.contractCode,
                    siteList: setCurrentSiteList(data)
                };
                const { params, apiUrl } = getCompanyParams(initParams, siteUpdateBatch, changeSiteUpdateBatch);
                const res = await apiUrl(params);
                if (res.code === '0') {
                    Message.success('保存成功');
                    subTabTable.getList();
                }
            } else if (handleType.value === 'company') {
                if (props.detailPageState === STATE_NEW) { // 新增状态，批量添加分公司弹框确认
                    data.map(item => {
                        item.allowEdit = true;
                        item.edit = 2;
                        item.disableProps = [];
                        // 合同“内外部业务”为内部时，合同分公司明细的“是否纯仓”赋默认值 N否，外部时不设置
                        item.isPureWarehouse = props.detailData.oilIsGroupCustomer + '' === '0' ? 'N' : null;
                        props.detailData.oilIsGroupCustomer + '' === '0' && item.disableProps.push('isPureWarehouse');
                        const currentData = editTableTotalData.value.find(it => item.companyCode === it.companyCode);
                        if (currentData) {
                            item.site = _.cloneDeep(currentData.site);
                        }
                        return item;
                    });
                    editTableTotalData.value = data;
                    editTableTotalData.value = _.uniqBy(editTableTotalData.value, 'companyCode');
                    // 获取当前重复数据，列表中已存在的数据
                    const siteList = _.filter(editTableTotalData.value, (it) => {
                        return allSiteList.value.some(val => val.companyCode === it.companyCode);
                    });
                    // 获取当前列表中已存在的服务平台数据
                    const siteFilter = _.flattenDeep(siteList.map(it => {
                        return it.site;
                    }));
                    // 获取allSiteList 和 siteFilter 交集数据，并获取allSiteList重复数据的值
                    allSiteList.value = _.intersectionBy(allSiteList.value, siteFilter, 'siteCode');
                    // editTableKey.value = !editTableKey.value;
                    setTimeout(() => {
                        editTableKey.value = !editTableKey.value;
                    }, 1000);
                    allCompanyList.value = editTableTotalData.value;
                } else { // 编辑合同,批量添加分公司确认
                    companySaveSure(data);
                }
            } else if (handleType.value === 'newSiteBatch') {
                setcompanyListForSiteList(data);
            }
            handleType.value = '';
        };
        // 设置当前已选择的数据
        const setCurrentSiteList = (data, contractCode) => {
            return data.map(it => {
                const _siteName = it.siteName || it.siteNameCn;
                const item = {
                    companyCode: it.companyCode,
                    companyName: it.companyName || it.companyNameCn,
                    siteCode: it.siteCode ? it.siteCode.trim() : it.siteCode,
                    siteName: _siteName ? _siteName.trim() : _siteName,
                    contractCode
                } || [];
                const currentItem = allSiteList.value.find(ele => ele.siteCode === it.siteCode);
                if (currentItem) {
                    item.id = currentItem.id;
                }
                return item;
            });
        };
        // 新增合同-批量添加服务平台
        const setcompanyListForSiteList = (data) => {
            editTableTotalData.value = editTableTotalData.value.map(item => {
                item.site = [];
                item.site = [...item.site, ...data.filter(it => it.companyCode === item.companyCode)];
                item.site = otherUtils.distinctData(item.site, 'siteCode');
                item.site = item.site.map(it => {
                    return {
                        siteCode: it.siteCode,
                        siteName: it.siteName || it.siteNameCn
                    };
                });
                return item;
            });
            if (!props.detailData.contractCode) {
                allSiteList.value = data;
            };
        };
        const detailCheckedList = () => {};
        // eslint-disable-next-line complexity
        const companySaveSure = async (data, type) => {
            let params = null;
            if (Array.isArray(data)) {
                params = data.map((item) => {
                    return {
                        ...item,
                        contractCode: props.detailData.contractCode,
                        contractChangeCode: props.detailData.contractChangeCode ? props.detailData.contractChangeCode : null,
                        // 合同“内外部业务”为内部时，合同分公司明细的“是否纯仓”赋默认值 N否，外部时不设置
                        isPureWarehouse: item.isPureWarehouse || (props.detailData.oilIsGroupCustomer + '' === '0' ? 'N' : null)
                    };
                });
            }
            let res = '';
            if (type && type === 'privilege') { // 特权新增
                res = await privilegeAddBatch(params);
            } else if (props.detailPageState === STATE_OTHER_CHANGE) {
                res = await otherChangeCompanyAddBatch(params);
            } else {
                /**
                 * 1、存在合同的时候，新增商机需要校验，成功才可以添加
                 * 2、添加完成之后调用合同详情接口，以及获取商机数据接口更新最大值提示
                */
                res = await companyAddBatch(params);
            }

            if (res && +res.code === 0) {
                Message.success('保存成功');
                await subTabTable.getList();
                if (props.detailPageState === STATE_OTHER_CHANGE) return;
                setupContext.emit('updataDetail');
                setupContext.emit('changeProjectCode', { list: params.map(it => it?.projectCode).filter(it => it), type: 'add' });
                const table = setupContext.refs.tableBoxRead;
                if (!table) return;
                const bodyWrapper = table.$el.querySelector('.company-detail-table .el-table__body-wrapper');
                if (!bodyWrapper) return;

                const maxScrollLeft = (bodyWrapper.scrollWidth - bodyWrapper.clientWidth) / 2;
                // 平滑滚动（behavior: 'smooth'）
                bodyWrapper.scrollTo({
                    left: maxScrollLeft,
                    behavior: 'smooth'
                });
            }
        };
        // const setOpportunityEmitData = async () => {
        //     if (props.detailPageState === STATE_OTHER_CHANGE) return;
        //     const { oilIsGroupCustomer, isLinkOppo } = props.detailData;
        //     const isEmitData = +oilIsGroupCustomer === 1 && +isLinkOppo === 1;
        //     if (!isEmitData) return;
        //     if (props.detailData.contractGroupCode) return;
        //     const maxRes = await getOpportunityOtherFiled(subTabTable.totalData.value);
        //     if (maxRes && +maxRes.code === 0) {
        //         setupContext.emit('changeContractDetail', maxRes.data);
        //     }
        // };
        const opportunityListVisible = ref(false); // 商机弹框
        const updateOpportunityListVisible = (val) => {
            opportunityListVisible.value = val;
        };
        const getMuiAdvceList = (data) => {
            const keys = Object.keys(data);
            const values = keys.map(key => data[key].split(','));
            // 构建对象数组
            const result = values[0].map((_, index) => {
                return keys.reduce((obj, key, i) => {
                    obj[key] = values[i][index];
                    return obj;
                }, {});
            });
            return result;
        };
        const addOpportunityConfirm = (data = {}, type, config = {}) => {
            const overseasType = 'overseasIntroduction__c'; // 海外业务类型
            const keys = Object.keys(data);
            const values = keys.map(key => data[key].split(','));
            // 构建对象数组
            const result = values[0].map((_, index) => {
                return keys.reduce((obj, key, i) => {
                    obj[key] = values[i][index];
                    return obj;
                }, {});
            });
            const overseasList = result.filter(it => it.opportunityEntityType !== overseasType)?.map(it => it.opportunityCode) || [];
            const exclusiveOverseasList = result.filter(it => it.opportunityEntityType === overseasType)?.map(it => it.opportunityCode) || [];
            // 合同属性为海外时判断商机必须为海外业务
            if (props.detailData.contractAttribute?.toString() === '2' && overseasList.length) {
                const tipsText = '当前为海外合同，关联商机只能为海外商机。以下商机不是海外商机，请核实。商机编码：';
                return Message.warning(tipsText + overseasList.join(','));
            } else if (props.detailData.contractAttribute?.toString() !== '2' && exclusiveOverseasList.length) { // 当海外业务时, 无
                // 合同属性为不是海外时,判断商机必须不能有海外业务
                const tipsTextOther = '当前非海外合同，关联商机不能为海外商机。以下商机是海外商机，请核实。商机编码：';
                return Message.warning(tipsTextOther + exclusiveOverseasList.join(','));
            }
            if (config.noCloseDialog && !props.detailData.contractChangeCode) {
                MessageBox.confirm('增减商机会更新合同的财务信息，请确认', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        setupContext.refs.advanceDialogRef.changeVisible(false);
                        addOpportunityConfirm2(data, type);
                    // 在这里执行确认后的逻辑
                    });
                return;
            }
            setupContext.refs.advanceDialogRef.changeVisible(false);
            addOpportunityConfirm2(data, type);
        };
        const addOpportunityConfirm2 = async (data = {}, type) => {
            updateOpportunityListVisible(false);
            updateOpportunityPrivilegeVisible(false);
            setupContext.refs.advanceDialogRef.changeVisible(false);
            const newData = getMuiAdvceList(data);
            if (props.detailPageState === STATE_NEW) { // 新增合同 (批量)
                try {
                    const res = await getOpportunityOtherFiled([...newData, ...editTableTotalData.value]);
                    // const verifyRes = await getEditOppList(newData);
                    // verifyRes = [newData[0].id];
                    const mergeData = newData;
                    //     if (verifyRes && +verifyRes.code === 0 && verifyRes.data) {
                    //         mergeData.forEach(item => {
                    //             const isColorTips = item.opportunityCode && !item.site?.length
                    // && +props.detailData.isLinkOppo === 1 && (props.detailPageState === STATE_NEW || +props.detailData.contractStatus === 0);
                    //             item.isModify = verifyRes.data.includes(item.id) && isColorTips ? '1' : 0;
                    //         });
                    //     }
                    if (res && +res.code === 0) {
                        pushDataFn(_.map(mergeData, obj => _.omit(obj, 'id'))); // 删除商机的id,避免新增的时候数据有问题
                        const isLinkOppo = [...newData, ...editTableTotalData.value].some(it => +it.isLinkOppo === 1) ? '1' : '';
                        setupContext.emit('changeContractDetail', _.cloneDeep({ ...(res.data || {}), isLinkOppo }));
                        setupContext.emit('changeProjectCode', { list: mergeData.map(it => it?.projectCode).filter(it => it), type: 'add' });
                    }
                } catch (e) {
                    Message.warning('逻辑异常');
                }
            } else { // 编辑合同 （单条）
                // 调分公司保存接口
                companySaveSure(_.map(newData, obj => _.omit(obj, 'id')), type); // 删除商机的id,避免新增的时候数据有问题
            }
        };
        // 判断是否可编辑
        // const getEditOppList = (data) => {
        //     if (props.detailPageState === STATE_OTHER_CHANGE) return;
        //     const parmas = data.map(it => it.opportunityId);
        //     return getCompanyVerify(parmas);
        // };
        const getOpportunityOtherFiled = (data) => {
            if (props.detailPageState === STATE_OTHER_CHANGE) return;
            const list = data.map(it => it.opportunityId).filter(it => it);
            return opportunityPreVerify(list);
        };
        const pushDataFn = (data) => {
            const list = _.cloneDeep(data);
            if (list && list.length) {
                list.forEach((item) => {
                    item.allowEdit = true;
                    item.edit = 2;
                    // 合同“内外部业务”为内部时，合同分公司明细的“是否纯仓”赋默认值 N否，外部时不设置
                    item.isPureWarehouse = item.isPureWarehouse || (props.detailData.oilIsGroupCustomer + '' === '0' ? 'N' : null);
                    item.disableProps = ['warehouseType']; // 禁用分公司编辑
                    if (+item.isModify !== 1) {
                        item.disableProps.push('companyName');
                    }
                });
                editTableTotalData.value = _.unionBy(editTableTotalData.value, list, 'opportunityCode');
                setTimeout(() => {
                    editTableKey.value = !editTableKey.value;
                }, 1000);
            }
        };
        const projectData = ref({});
        const changeIsWarehouse = (row, data) => {
            companySaveSure([row]);
        };
        // 业务类别包含：“仓储/装卸”时，分公司明细的“是否纯仓”不能为空（校验） 内部和外部合同都要校验
        const checkIsWarehouse = (rows) => {
            const { businessType } = props.detailData;
            if (businessType && businessType.length && businessType.some(item => (item === '1' || item === '2'))
                && rows.some(item => !item.isPureWarehouse)) {
                Message.warning('业务类别包含：“仓储/装卸”时，分公司明细的“是否纯仓”不能为空');
                return false;
            } else {
                return true;
            }
        };
        const allSiteList = ref([]);
        const getAllSitList = () => {
            if (!props.detailData.contractCode) return;
            const { params, apiUrl } = getCompanyParams({}, getSiteInfoCompanyAll, getChangeSiteInfoCompanyAll);
            return apiUrl(params).then((res) => {
                if (res && +res.code === 0) {
                    allSiteList.value = res.data.map(it => {
                        it.siteNameCn = it.siteName;
                        return it;
                    });
                }
            }).catch(() => {
                allSiteList.value = [];
            });
        };
        const handleAddSiteBatch = async () => {
            const _list = props.detailData.contractCode ? subTabTable.totalData.value : editTableTotalData.value;
            if (!checkIsWarehouse(_list)) {
                return false;
            }
            await getAllSitList();
            if (props.detailData.contractCode) {
                const { params } = getCompanyParams({});
                setupContext.refs.advanceMultiDialog.show(true, config.siteAdvancePrivilegeParams, params, allSiteList.value);
                handleType.value = 'siteBatch';
            } else {
                const companyList = editTableTotalData.value?.map(item => item.companyCode) || [];
                setupContext.refs.advanceMultiDialog.show(true, config.siteAdvancePrivilegeParams, { companyCodeList: companyList }, allSiteList.value);
                handleType.value = 'newSiteBatch'; // 新增合同-批量添加服务平台
            }
        };
        const hiddenSiteBatch = ref(false);
        const getSiteBatchBtn = () => {
            if (!props.detailData.contractCode || props.readonly) {
                return true;
            }
            getSiteBatch({ contractCode: props.detailData.contractCode }).then((res) => {
                if (res && +res.code === 0) {
                    hiddenSiteBatch.value = res.data; // true：重复，既不显示按钮
                }
            }).catch(() => {

            });
        };
        // eslint-disable-next-line complexity
        const setCellCassName = ({ row, column, rowIndex, columnIndex }) => {
            if (column.property === 'companyName') {
                const isEdit = row.opportunityCode && +row.isModify === 1 && !row.siteNames?.length
                && (props.detailPageState === STATE_NEW || [0, 1].includes(+props.detailData.contractStatus));
                return isEdit ? 'company-red-tips' : '';
            } else if (column.property === 'isPureWarehouse') {
                const businessType = props.detailData.businessType;
                const isShowBorder = Boolean(businessType && businessType.length && businessType.some(item => (item === '1' || item === '2'))) && _.isNil(row.isPureWarehouse);
                return isShowBorder ? 'company-red-tips' : '';
            }
        };
        onMounted(async() => {
            // try {
            //     let mergeData = props.detailData.opportunityList;
            //     if (props.detailData.opportunityList.length) {
            //         const verifyRes = await getEditOppList(props.detailData.opportunityList);
            //         // verifyRes = [newData[0].id];
            //         mergeData = props.detailData.opportunityList;
            //         if (verifyRes && +verifyRes.code === 0 && verifyRes.data) {
            //             mergeData.forEach(item => {
            //                 const isColorTips = item.opportunityCode && !item.site.length
            //     && +props.detailData.isLinkOppo === 1 && (props.detailPageState === STATE_NEW || +props.detailData.contractStatus === 0);
            //                 item.isModify = verifyRes.data.includes(item.id) && isColorTips ? '1' : 0;
            //             });
            //             mergeData = _.map(mergeData, obj => _.omit(obj, 'id'));
            //         }
            //     }
            //     pushDataFn(mergeData); // 删除商机的id,避免新增的时候数据有问题
            // } catch (e) {
            pushDataFn(props.detailData.opportunityList); // 预填充商机（分公司）信息
            // }
        });
        return {
            config,
            actions,
            subTabTable,
            btnLoading,
            handleAddRow,
            handleSelectedRow,
            handleChangeRow,
            handleDeleteRows,
            getAdvanceValue,
            STATE_NEW,
            STATE_OTHER_CHANGE,
            siteDetailData,
            actionClick,
            companySaveSure,
            detaliSearchSure,
            detailCheckedList,
            isDisableBtn,
            editTableTotalData,
            authorityCode,
            opportunityListVisible,
            updateOpportunityListVisible,
            opportunityPrivilegeVisible,
            updateOpportunityPrivilegeVisible,
            addOpportunityConfirm,
            projectData,
            btnPermissionsArr,
            handleSyncData,
            changeIsWarehouse,
            editTableKey,
            opportunityAdvance,
            handleRowClick,
            privilegeDeleteLoading,
            handleAddSiteBatch,
            privilege,
            hiddenSiteBatch,
            isShowCompany,
            isShowTips,
            setCellCassName,
            isShowOppBtn
        };
    }
};
</script>
<style scoped lang="less">
.red-tips{
    color: #f56c6c;
    font-size: 12px;
}
</style>
<style lang="less">
    .company-detail-table {
        .el-button+.el-button {
            margin-left: 0;
        }
        .el-button {
            margin-right: 10px;
        }
    }
    // .company-red-tips{
    //     border: 1px solid red!important;
    // }
    .company-red-tips {
        position: relative;
    }
    .company-red-tips::after {
        content: '';
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        border: 1px solid #f56c6c;
        pointer-events: none;
        z-index: 1;
    }
</style>
